import React from 'react';
import { Panel } from 'src/modules/shared/components/molecules/panel';
import { PanelHeader } from 'src/modules/shared/components/molecules/panel/panel-header';
import { Text } from 'src/modules/shared/components/atoms/text';
import { FunnelManagementPanel } from '../organisms/funnels/funnel-management-panel';
import { UnsavedChangesModal } from 'src/modules/shared/components/molecules/modals/unsaved-changes-modal';
import { useUnsavedNavigationGuardState } from 'src/modules/shared/hooks/unsaved-navigation-guard';
import { PiTreeStructureLight } from 'react-icons/pi';

export const FunnelsSettingsPage: React.FC = () => {
  const guard = useUnsavedNavigationGuardState(false);

  return (
    <div className="flex flex-col h-full">
      <Panel className="h-full flex flex-col">
        <PanelHeader className="px-4 py-3 border-b">
          <div className="flex items-center gap-4">
            <PiTreeStructureLight className="w-8 h-8" />
            <Text as="h2" size="h2" weight="medium">
              {/* TODO: check when implementing i18n */}
              Embudos
            </Text>
          </div>
        </PanelHeader>

        <div className="flex-1 overflow-auto p-4">
          <FunnelManagementPanel
            onHasUnsavedChanges={guard.setHasUnsavedChanges}
          />
        </div>
      </Panel>

      <UnsavedChangesModal
        isOpen={guard.isBlocked}
        onProceed={guard.proceed}
        onStay={guard.stay}
      />
    </div>
  );
};
